import { render, staticRenderFns } from "./deliveryareanotdutySetting.vue?vue&type=template&id=1b355b2e&scoped=true"
import script from "./deliveryareanotdutySetting.vue?vue&type=script&lang=js"
export * from "./deliveryareanotdutySetting.vue?vue&type=script&lang=js"
import style0 from "./deliveryareanotdutySetting.vue?vue&type=style&index=0&id=1b355b2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b355b2e",
  null
  
)

export default component.exports